import React from "react";

import {
  PrimaryBlockType,
  primaryBlock,
  PrimaryBlockConfig,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  getDefaultProps,
  BlockType,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { Variants } from "@kameleon-util/global-theme";
import { LayoutProps } from "../types/prop-types";
import defaults from "../defaults.json";

type Item = {
  header: string;
  description: string;
};

export type ContentCollectionItemType = {
  /** Place prop documentation here */
  tab: string;
  items: Item[];
  _parentBgColor?: string;
} & PrimaryBlockType<LayoutProps>;

/** ContentCollectionItem PrimaryCollection */
export const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Medium,
  tertiaryBlockSize: TertiaryBlockSize.None,
  blockTheme: BlockTheme.light,
  blockType: BlockType.PrimaryCollection,
};

export const ContentCollectionItem = primaryBlock<ContentCollectionItemType>(
  { isInnerBlock: true, ...blockConfig },
  ({ SecondaryBlock, items, _parentBgColor }: ContentCollectionItemType) => (
    <Box
      sx={{ backgroundColor: _parentBgColor || "transparent" }}
      className="primary-collection-content-collection-two-col-tabs-rows-v1"
    >
      <Box className="career21_list-wrapper">
        <Box className="career21_list">
          {items.map((item, index) => (
            <Variants.Card key={index} className="career21_item">
              <Box className="margin-bottom margin-medium">
                <Box className="career21_top-wrapper">
                  <Box className="career21_title-wrapper">
                    <Variants.Heading as="h3" variant="h5">
                      {item.header}
                    </Variants.Heading>
                  </Box>
                </Box>
              </Box>
              <Box className="margin-bottom margin-small">
                <Variants.ParagraphDefault>
                  {item.description}
                </Variants.ParagraphDefault>
              </Box>
              {renderSecondaryBlock(SecondaryBlock)}
            </Variants.Card>
          ))}
        </Box>
      </Box>
    </Box>
  )
);

const itemDefaults = {
  layoutProps: defaults.layoutProps,
  contentProps: defaults.contentProps.PrimaryBlocks[0] ?? {},
};
ContentCollectionItem.defaultProps =
  getDefaultProps<ContentCollectionItemType>(itemDefaults);
